module.exports = __webpack_public_path__ + "static/water_glacier17-99da4fb19269b97daf20ce8a48f2d834.jpg";